import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {Dimensions} from 'react-native';
import {isIphoneX} from 'react-native-iphone-screen-helper';

interface ICategoryProductProps {
  inactive?: boolean;
}

export const Container = styled.View`
flex:1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  flex: 1;
`;

export const Empty = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(14)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const HelpButtonContainer = styled.View`
  flex-direction: row;
`;

export const ContentHeader = styled.View`
  flex-direction: column;

  padding: 0 24px;
  justify-content: space-between;
`;

export const LinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
  margin-left: ${RFValue(12)}px;
`;

export const LinkButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Subtitle = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  margin-bottom: ${RFValue(4)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const SelectProductCategoryContainer = styled.ScrollView``;

export const Row = styled.View`
  flex-direction: row;
  padding: 0 24px;
  width: 100%;
  justify-content: space-between;
  margin-top: ${RFValue(10)}px;
`;
export const ProductCategoryItem = styled.TouchableOpacity<ICategoryProductProps>`
  width: 50%;
  shadow-color: ${({theme}) => theme.colors.dark_shadow};
  shadow-offset: 0px 4px;
  shadow-opacity: 0.1;
  shadow-radius: 4px;
  elevation: 2;
  ${({inactive}) =>
    inactive &&
    css`
      opacity: 0.2;
    `}
`;

const imageDimensions = isIphoneX()
  ? Dimensions.get('window').width >= 393 &&
    Dimensions.get('window').width < 430
    ? RFValue(58)
    : Dimensions.get('window').width >= 394 &&
      Dimensions.get('window').width < 431
    ? RFValue(62)
    : RFValue(68)
  : RFValue(72);

  //@ts-ignore
export const ProductCategoryImage = styled(FastImage)`
  height: ${imageDimensions}px;

  border-radius: ${RFValue(12)}px;
`;

export const ProductMask = styled.View`
  height: ${imageDimensions}px;
  width: 100%;
  background-color: #000;
  position: absolute;
  opacity: 0.25;
  z-index: 1;

  border-radius: ${RFValue(14)}px;
`;

export const ProductCategoryInfos = styled.View`
  position: absolute;
  margin: ${RFValue(9)}px;
  z-index: 2;
`;

export const ProductTypeName = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(11)}px;
  flex: 1;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const LinksButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const SearchInputContainer = styled.View`
  padding:${RFValue(4)}px 24px;

`;
